<template>
  <div id="app">
     <!-- 1. 监听 Header 的两个事件：select-product 和 go-home -->
    <AppHeader 
     :current-active="activeMenu"
      @select-product="showProductDetail" 
      @go-home="goBack" 
       @navigate-to-section="handleNavigateToSection"
    />
     <!-- 显示首页 -->
    <div v-if="!currentProduct">
    <!-- <AppHeader /> -->
    <AppBanner />
    <ProductMatrix @show-detail="showProductDetail" @select-product="showProductDetail"/>
    <ServiceSupport>
  <template #icon-1>
    <img src="@/assets/custom-icon-1.png" style="width: 72px; height: 72px; object-fit: contain;" alt="专属方案">
  </template>
  <template #icon-2>
    <img src="@/assets/custom-icon-2.png"  style="width: 72px; height: 72px; object-fit: contain;" alt="部署实施">
  </template>
  <template #icon-3>
    <img src="@/assets/custom-icon-3.png"  style="width: 72px; height: 72px; object-fit: contain;" alt="部署实施">
  </template>
  <template #icon-4>
    <img src="@/assets/custom-icon-4.png"  style="width: 72px; height: 72px; object-fit: contain;" alt="部署实施">
  </template>
  <template #icon-5>
    <img src="@/assets/custom-icon-6.png"  style="width: 72px; height: 72px; object-fit: contain;" alt="部署实施">
  </template>
  <!-- 以此类推 -->
</ServiceSupport>
    <AppAdvantages />
    <CompanyIntro />
    <AppFooter />
     </div>

    <!-- 显示产品详情页 -->
    <!-- <ProductDetail v-else @back-to-home="goBackToHome" /> -->
         <!-- 2. 校园视频公话详情页 -->
    <ProductDetail 
      v-else-if="currentProduct === 'video-phone'" 
      @back="goBack" 
    />

    <!-- 3. 防霸凌预警系统详情页 (新增) -->
    <AntiBullyingDetail 
      v-else-if="currentProduct === 'anti-bullying'" 
      @back="goBack" 
    />
        <!-- 4. 电子班牌系统详情页 (新增) -->
    <ElectronicClassCard 
      v-else-if="currentProduct === 'class-card'" 
      @back="goBack" 
    />
     <!-- 5. AI数字人图书检索系统详情页 (新增) -->
    <AILibrarySearch 
      v-else-if="currentProduct === 'ai-book'" 
      @back="goBack" 
    />
     <!-- 6. AI数字人相框系统详情页 (新增) -->
    <AIVoiceInteraction 
      v-else-if="currentProduct === 'ai-voice'" 
      @back="goBack" 
    />
    <PsychologicalCounseling v-else-if="currentProduct === 'ai-psychology'" 
      @back="goBack"></PsychologicalCounseling>
    <MoraleducationEvaluation v-else-if="currentProduct === 'moral-eval'" 
      @back="goBack"></MoraleducationEvaluation>
    <!-- 7. 其他产品 (占位) -->
    <div v-else class="other-product-placeholder">
      <!-- <AppHeader /> -->
      <div style="height: 60vh; display: flex; flex-direction: column; align-items: center; justify-content: center; background: #f8fafc;">
        <p style="color: #666; margin: 20px 0;">敬请期待</p>
        <button @click="goBack" style="padding: 10px 20px; background: #1a73e8; color: white; border: none; border-radius: 5px; cursor: pointer;">返回产品矩阵</button>
      </div>
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppBanner from './components/AppBanner.vue'
import ProductMatrix from './components/ProductMatrix.vue'
import ServiceSupport from './components/ServiceSupport.vue'
import AppAdvantages from './components/AppAdvantages.vue'
import CompanyIntro from './components/CompanyIntro.vue'
import AppFooter from './components/AppFooter.vue'
import ProductDetail from './components/ProductDetail.vue'
import AntiBullyingDetail from './components/AntiBullyingDetail.vue' 
import ElectronicClassCard from './components/ElectronicClassCard.vue'
import AILibrarySearch from './components/AILibrarySearch.vue' 
import AIVoiceInteraction from './components/AIVoiceInteraction.vue' 
import PsychologicalCounseling from './components/psychologicalCounseling.vue'
import MoraleducationEvaluation from './components/MoraleducationEvaluation.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppBanner,
    ProductMatrix,
    ServiceSupport,
    AppAdvantages,
    CompanyIntro,
    AppFooter,
    ProductDetail,
    AntiBullyingDetail,
    ElectronicClassCard,
    AILibrarySearch,
    AIVoiceInteraction,
    PsychologicalCounseling,
    MoraleducationEvaluation
  },
  data() {
    return {
      activeMenu: 'home',
      currentProduct: null // null 表示首页，'video-phone' 表示视频电话，'anti-bullying' 表示防霸凌
    }
  },
  methods: {
    showProductDetail(productId) {
      // console.log('显示产品详情:', productId)
      // this.currentPage = 'product-detail'
      this.currentProduct = productId
      this.activeMenu = productId 
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goBackToHome() {
       this.currentProduct = null
      // 滚动到顶部
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goBack() {
       this.currentProduct = null
        //  this.activeMenu = productId
        this.activeMenu = 'home' // 返回首页时高亮首页 
      // 滚动到顶部
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // 新增：统一处理锚点跳转逻辑
    handleNavigateToSection(id) {
      
      // 场景 1：当前在产品详情页，需要先返回首页
      if (this.currentProduct !== null) {
        // console.log('00000');
        
        this.currentProduct = null; // 切换回首页视图
        this.activeMenu = id;       // 更新导航高亮
        
        // 瞬间回到顶部（behavior: 'auto'），避免和后续的平滑滚动冲突
        window.scrollTo({ top: 0, behavior: 'auto' });
        
        // 等待首页 DOM (ServiceSupport 等) 渲染完成后，再执行滚动
        this.$nextTick(() => {
          this.performSmoothScroll(id);
        });
      } 
      // 场景 2：当前已经在首页，直接平滑滚动即可
      else {
        this.activeMenu = id;
        this.$nextTick(() => {
          this.performSmoothScroll(id);
        });
      }
    },

    // 提取出来的纯滚动逻辑
    performSmoothScroll(id) {
      const el = document.getElementById(id);
      if (el) {
        const elementPosition = el.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset;
        const headerOffset = 80; // Header 高度 70px + 10px 呼吸间距
        
        window.scrollTo({
          top: offsetPosition - headerOffset,
          behavior: 'smooth'
        });
      }
    }
  }
}
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  line-height: 1.6;
}

body {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
  color: inherit;
}

ul {
  list-style: none;
}
</style>